// extracted by mini-css-extract-plugin
export default {"trigger":"Trigger_trigger__E1Swt","normal":"Trigger_normal__kfp2d","pushed":"Trigger_pushed__1a1l+","flat":"Trigger_flat__i1WT4"};